export function requiredValidationRule(value: string | null | undefined): boolean | string {
  return !!value || 'Required';
}

export function getMaxlengthValidationRule(maxlength: number) {
  return (value: string | null | undefined): boolean | string => {
    const isSuccess = !value || value.length <= maxlength;
    return isSuccess || `Max ${maxlength} characters`;
  };
}
